import React, { useEffect, useState, useContext } from "react"
//import { AppContext } from "../Context";
import { AuthActionsContext } from "./useAuthActions";
import { useCookie } from "./LocalService";
import { RouteDashboard, RouteLogin, RouteOrcamentos, RouteRoot, RouteTarefas, RouteUsuarios } from "../PathRoutes";

const Navbar = () => {
    let Auth = AuthActionsContext();
    let cookie = useCookie();
    useEffect(() => {
        
        if (window.location.pathname !== RouteLogin)    
            Auth.checkLogin();
    },[Auth]);

    return (
        <div>
            <ul id="dropdown1" class="dropdown-content">
                <li><a href="#">{cookie.get("UserOB")}</a></li>
                <li><a href="#"><hr/></a></li>
                <li><a href={RouteLogin}><i class="material-icons left">exit_to_app</i>Logoff</a></li>
            </ul>            
            <nav>
                <div className="nav-wrapper container">
                    <a href={RouteDashboard} className="brand-logo"><i className="material-icons hide-on-med-and-down" style={{fontSize:2.5+'rem'}}>insert_invitation</i>Organização</a>                    
                    {(window.location.pathname !== RouteLogin && window.location.pathname !== RouteRoot)?(
                        <>
                            <ul id="slide-out" className="sidenav">
                                {cookie.get("Perfil") === "adm" || cookie.get("Perfil") === "dev"?(
                                    <>
                                    <li><a href={RouteTarefas}><i class="material-icons left">task</i>Tarefas</a></li>
                                    <li><a href={RouteOrcamentos}><i className="material-icons left">folder</i>Orçamentos</a></li>
                                    </>):("")
                                }
                                {cookie.get("Perfil") === "dev"?(
                                    <>
                                    <li><a href={RouteUsuarios}><i class="material-icons left">people</i>Usuarios</a></li>
                                    </>):("")
                                }
                                {/*<li><a href="/despesas">Despesas</a></li>*/}
                                <li><a href="#"><hr/></a></li>
                                <li><a href="#"><i class="material-icons left">person</i>{cookie.get("UserOB")}</a></li>
                                <li><a href={RouteLogin}><i class="material-icons left">exit_to_app</i>Logoff</a></li>
                            </ul>

                            <ul id="nav-mobile" className="right hide-on-med-and-down">
                                {cookie.get("Perfil") === "adm" || cookie.get("Perfil") === "dev"?(
                                    <>
                                    <li><a href={RouteTarefas}><i className="material-icons left">task</i>Tarefas</a></li>
                                    <li><a href={RouteOrcamentos}><i className="material-icons left">folder</i>Orçamentos</a></li>
                                    </>):("")
                                }
                                {cookie.get("Perfil") === "dev"?(
                                    <>
                                    <li><a href={RouteUsuarios}><i className="material-icons left">people</i>Usuarios</a></li>
                                    </>):("")
                                }
                                {/*<li><a href="/despesas">Despesas</a></li>*/}
                                <li><a className="dropdown-trigger" href="#" data-target="dropdown1"><i className="material-icons">person</i></a></li>
                            </ul>

                            <a href="#" data-target="slide-out" className="sidenav-trigger"><i className="material-icons">menu</i></a>
                        </>):
                        <ul id="nav-mobile" className="right hide-on-med-and-down">
                            <span>Faça o login!</span>
                        </ul>
                        
                        }
                </div>
            </nav>
        </div>
    );
}

export default Navbar;